export default __webpack_public_path__ + "static/media/hiper.fb7d59ff.png";